export enum ContentOpinionType {
    Positive = 0,
    Negative = 1,
}
